import { useState } from 'react';

const galleryImages = [
  {
    url: 'https://readdy.ai/api/search-image?query=car%20engine%20block%20detailed%20mechanical%20parts%20pistons%20cylinders%20dark%20dramatic%20lighting%20automotive%20photography%20professional%20studio%20high%20resolution&width=600&height=800&seq=gal001&orientation=portrait',
    alt: 'Motor automotriz de alta performance',
    span: 'row-span-2',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=brake%20disc%20caliper%20automotive%20parts%20dark%20background%20professional%20photography%20chrome%20metal%20high%20detail%20studio%20lighting&width=600&height=400&seq=gal002&orientation=landscape',
    alt: 'Discos y calibradores de freno',
    span: '',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=car%20suspension%20control%20arm%20ball%20joint%20mechanical%20parts%20dark%20studio%20background%20automotive%20spare%20parts%20professional&width=600&height=400&seq=gal003&orientation=landscape',
    alt: 'Sistema de suspensión vehicular',
    span: '',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=automotive%20gearbox%20transmission%20mechanical%20components%20dark%20background%20professional%20photography%20metal%20industrial%20high%20detail&width=600&height=400&seq=gal004&orientation=landscape',
    alt: 'Caja de transmisión mecánica',
    span: '',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=shock%20absorber%20strut%20spring%20automotive%20parts%20dark%20background%20professional%20studio%20photography%20chrome%20metal&width=600&height=800&seq=gal005&orientation=portrait',
    alt: 'Amortiguadores y espirales',
    span: 'row-span-2',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=car%20water%20pump%20cooling%20system%20mechanical%20parts%20dark%20background%20automotive%20spare%20parts%20professional%20photography&width=600&height=400&seq=gal006&orientation=landscape',
    alt: 'Bomba de agua y sistema de refrigeración',
    span: '',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=clutch%20kit%20disc%20pressure%20plate%20automotive%20mechanical%20parts%20dark%20studio%20background%20professional%20photography&width=600&height=400&seq=gal007&orientation=landscape',
    alt: 'Kit de embrague completo',
    span: '',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=automotive%20spare%20parts%20store%20shelves%20organized%20mechanical%20components%20dark%20background%20professional%20photography%20industrial&width=600&height=400&seq=gal008&orientation=landscape',
    alt: 'Almacén de repuestos mecánicos',
    span: '',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState<string | null>(null);

  return (
    <section id="galeria" className="bg-[#0d0d0d] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <i className="ri-image-line"></i>
            Galería Visual
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Nuestro Trabajo en <span className="text-[#2563eb]">Imágenes</span>
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            Repuestos mecánicos de alta calidad para mantener tu vehículo en perfectas condiciones.
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 auto-rows-[160px] sm:auto-rows-[180px] md:auto-rows-[200px]">
          {galleryImages.map((img, idx) => (
            <div
              key={idx}
              className={`relative overflow-hidden rounded-xl cursor-pointer group ${img.span ? 'md:row-span-2' : ''}`}
              onClick={() => setLightbox(img.url)}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className="ri-zoom-in-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-xl"></i>
          </button>
          <img
            src={lightbox}
            alt="Repuesto mecánico"
            className="max-w-full max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
